module.exports = {"id":"235945","name":"Marc Roca","rating":"74","photo":"./data/images/photos/4/235945.png","club":{"name":"Esp. Barcelone","logo":"./data/images/clubs/Esp.Barcelone.png"},"positions":["MDC","MC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MarcRoca0.json
// module id = 2701
// module chunks = 0